'use client';

import { FC } from 'react';
import { useTheme } from 'next-themes';
import clsx from 'clsx';
import { MonitorCogIcon, MoonIcon, SunIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from '@/components/ui/tooltip';

export interface ThemeSwitchProps {
  className?: string;
}

export const ThemeSwitch: FC<ThemeSwitchProps> = ({ className }) => {
  const { theme, setTheme } = useTheme();

  // 确定当前图标
  const getIcon = (themeType: string) => {
    switch (themeType) {
      case 'light':
        return <SunIcon className="h-4 w-4" />;
      case 'dark':
        return <MoonIcon className="h-4 w-4" />;
      case 'system':
        return <MonitorCogIcon className="h-4 w-4" />;
      default:
        return <SunIcon className="h-4 w-4" />;
    }
  };

  return (
    <div
      className={clsx(
        'flex border border-neutral-200 rounded-full dark:border-neutral-700',
        className,
      )}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            onClick={() => setTheme('light')}
            aria-label="Switch to light mode"
            className={cn('w-6 h-6 min-w-6 rounded-full bg-transparent', {
              'bg-neutral-200 dark:bg-neutral-700': theme === 'light',
            })}
          >
            {getIcon('light')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>浅色</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            onClick={() => setTheme('dark')}
            aria-label="Switch to dark mode"
            className={cn('w-6 h-6 min-w-6 rounded-full bg-transparent', {
              'bg-neutral-200 dark:bg-neutral-700': theme === 'dark',
            })}
          >
            {getIcon('dark')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>深色</p>
        </TooltipContent>
      </Tooltip>

      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            onClick={() => setTheme('system')}
            aria-label="Switch to system mode"
            className={cn('w-6 h-6 min-w-6 rounded-full bg-transparent', {
              'bg-neutral-200 dark:bg-neutral-700': theme === 'system',
            })}
          >
            {getIcon('system')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          <p>系统</p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
};
